import { createSlice } from "@reduxjs/toolkit";
import { fetchBooks, fetchCategories } from './BooksAction'

const initialState = {
    books: [],
    categories: [],
    // helpers
    error: null,
    loading: false,
    success: false,
}

export const BooksSlice = createSlice({
    name: 'books',
    initialState: initialState,

    extraReducers: (builder) => {

        // fetch Books cases
        builder.addCase(fetchBooks.pending, (state, action) => {
            state.error = false;
            state.loading = true;
        })
        builder.addCase(fetchBooks.fulfilled, (state, action) => {

            state.books = action.payload.approvedAds;
            state.success = true;
            state.loading = false;
        })
        builder.addCase(fetchBooks.rejected, (state, action) => {
            state.success = false;
            state.loading = false;
            state.error = action.payload;
        })


        // fecth categories cases
        builder.addCase(fetchCategories.pending, (state) => {
            state.error = false;
            state.loading = true;
        })
        builder.addCase(fetchCategories.fulfilled, (state, action) => {

            state.categories = action.payload.categories;
            state.success = true;
            state.loading = false;
        })
        builder.addCase(fetchCategories.rejected, (state, action) => {
            state.success = false;
            state.loading = false;
            state.error = action.payload;
        })
    }

})

export default BooksSlice.reducer
